import { RecurrenceIntervalUnitEnum } from '@ulysses-inc/harami_api_client'
import {
  INTERVAL_UNIT_OF,
  LAST_DAY_OPTIONS,
  type TaskScheduleForm,
  UNIT_LABEL,
  WEEKDAYS,
  isSingleDayPeriod,
} from './taskScheduleForm'

const monthDayLabel = (value: number) =>
  value > 0
    ? `${value} 日`
    : (LAST_DAY_OPTIONS.find(o => o.value === value)?.label ?? `${value}`)

const sortedMonthDays = (values: number[]) =>
  // 頭から数える日を昇順、そのあとに末日系を末日から近い順（-1, -2, -3）
  [...values].sort((a, b) => {
    if (a > 0 && b > 0) return a - b
    if (a < 0 && b < 0) return b - a
    return a > 0 ? -1 : 1
  })

/** 締切が開始以下なら翌日の締切。"翌 01:00" のように読む */
const timeRange = (startTime: string, dueTime: string) => {
  const start = startTime || '--:--'
  const due = dueTime || '--:--'
  const wraps = startTime !== '' && dueTime !== '' && dueTime <= startTime
  return `${start}〜${wraps ? '翌 ' : ''}${due}`
}

/**
 * 設定を二文で読み上げる（「設定の意味」）。前半はタスクの開始日がいつ来るか、後半はそこから何をいつまでに提出するか。
 * フォームの値だけから組み、サーバの結果は使わない。値が正しいかはここでは見ない。
 */
export const readback = (form: TaskScheduleForm): string => {
  const unit = INTERVAL_UNIT_OF[form.repeat]
  const n = form.interval
  const weekdays = WEEKDAYS.filter(w => form.weekdays.includes(w.code))
    .map(w => w.label)
    .join('・')
  const months = [...form.months]
    .sort((a, b) => a - b)
    .map(m => `${m} 月`)
    .join('・')
  const monthDays = sortedMonthDays(form.monthDays)
    .map(monthDayLabel)
    .join('と')

  let when: string
  switch (form.repeat) {
    case 'daily':
      when = '毎日'
      break
    case 'ndays':
      when = `${n} 日おき`
      break
    case 'weekly':
      when = `${n === 1 ? '毎週' : `${n} 週ごとの`}${weekdays}曜`
      break
    case 'monthly':
      when = `${n === 1 ? '毎月 ' : `${n} か月ごとの `}${monthDays}`
      break
    case 'yearly':
      when = `${n === 1 ? '毎年 ' : `${n} 年ごとの `}${months} ${monthDays}`
      break
  }
  const first = `${when}がタスクの開始日です。`

  if (!isSingleDayPeriod(form)) {
    const unitLabel =
      unit === RecurrenceIntervalUnitEnum.Month ? 'か月' : UNIT_LABEL[unit]
    const span = unit === RecurrenceIntervalUnitEnum.Week ? '週間' : unitLabel
    return `${first}開始日から ${form.plannedPeriodValue} ${span}のあいだに提出します。`
  }
  return `${first}その日の ${timeRange(form.startTime, form.dueTime)} に提出します。`
}
